import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { useCentro } from "@/lib/centro";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const viernes = (hoy) => new Date(hoy.getTime() + [5, 4, 3, 2, 1, 0, 6][hoy.getDay()] * 86400000);

export const HuecosLibres = () => {
  const { centro } = useCentro();
  const [rows, setRows] = useState(null);
  const [profs, setProfs] = useState({});
  useEffect(() => {
    const hoy = new Date();
    const fin = viernes(hoy);
    const ahora = `${String(hoy.getHours()).padStart(2, "0")}:${String(hoy.getMinutes()).padStart(2, "0")}`;
    api.get("/agenda-huecos", { params: { desde: iso(hoy), hasta: iso(fin), centro } })
      .then((r) => setRows(r.data.filter((h) => ["evaluacion", "revision"].includes(h.tipo) && !(h.fecha === iso(hoy) && h.inicio < ahora))));
    api.get("/profesionales", { params: { centro } }).then((r) => setProfs(Object.fromEntries(r.data.map((p) => [p.id, p.nombre]))));
  }, [centro]);
  if (!rows?.length) return null;
  const ev = rows.filter((h) => h.tipo === "evaluacion");
  const rv = rows.filter((h) => h.tipo === "revision");
  const lista = (l) => l.slice(0, 6).map((h) => `${fmtDate(h.fecha).slice(0, 5)} ${h.inicio} ${(profs[h.profesional_id] || "").split(" ")[0]}`).join(" · ");
  return (
    <Link to="/agenda" className="mb-8 flex flex-wrap items-center gap-x-6 gap-y-2 bg-white border border-sky-200 rounded-lg p-4 hover:border-sky-400 fade-up" data-testid="huecos-libres">
      <CalendarCheck className="h-5 w-5 text-sky-700" />
      <div><p className="text-sm font-semibold text-slate-800">Huecos libres esta semana</p><p className="text-[11px] text-slate-500">Pulsa para ir a la agenda y llenarlos</p></div>
      <div data-testid="huecos-libres-eval"><b className="text-2xl font-[Outfit] text-[#1E3A8A]">{ev.length}</b> <span className="text-xs text-slate-600">de evaluación</span>{ev.length > 0 && <p className="text-[11px] text-slate-500">{lista(ev)}{ev.length > 6 ? "…" : ""}</p>}</div>
      <div data-testid="huecos-libres-rev"><b className="text-2xl font-[Outfit] text-sky-600">{rv.length}</b> <span className="text-xs text-slate-600">de revisión</span>{rv.length > 0 && <p className="text-[11px] text-slate-500">{lista(rv)}{rv.length > 6 ? "…" : ""}</p>}</div>
    </Link>
  );
};
